
export default class EmergencyWarning {
    private defaultLanguageId: number;

    async init(): Promise<void> {
                const wrapper = document.querySelector('[data-component="EmergencyWarning"]') as HTMLElement;
        const messageGetUrl = wrapper.dataset.messageGetUrl;
        const languageId = wrapper.dataset.languageId;
        this.defaultLanguageId = Number(wrapper.dataset.defaultLanguageId);

        var emergencyMessage = await this.GetEmergencyWarning(messageGetUrl, Number(languageId));
        if (emergencyMessage) {
            wrapper.innerHTML = `<h2 id="emergency-message">${emergencyMessage}</h2>`;
            wrapper.removeAttribute("hidden");
        }
        else {
            wrapper.setAttribute("hidden", "");
            wrapper.innerHTML = "";
        }
        /* Is "Floating Header" presented inside DOM? */
        const isFixedHeaderActive: boolean = (document.querySelector('header.fixed') !== null) ? true : false;
        if (isFixedHeaderActive) {
            const elemWarning: HTMLElement | null = document.querySelector('[data-component="EmergencyWarning"]');
            const warningHeight: number = elemWarning ? elemWarning.getBoundingClientRect().height : 0;
            const fixedHeader: HTMLElement | null = document.querySelector('header.fixed');
            if (fixedHeader) {
                fixedHeader.setAttribute('style', 'top:' + warningHeight + 'px');
            }
        }
    }

    private async GetEmergencyWarning(messageGetUrl: string, languageId: number): Promise<string> {
        const response = await fetch(messageGetUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        });

        const json = await response.text();
        const emergencyWarningResponses = JSON.parse(json) as EmergencyWarningResponse[];
        var activeResponse = emergencyWarningResponses.filter(x => x.IsActive);

        if (activeResponse[0]) {
            var localisedMessage = activeResponse[0].Messages.filter(x => x.LanguageId === languageId);
            if (localisedMessage.length ===0) {
                localisedMessage = activeResponse[0].Messages.filter(x => x.LanguageId === this.defaultLanguageId);
            }

            return localisedMessage[0]?.Message;
        }
    }
}

interface EmergencyWarningResponse {
    IsActive: boolean;
    Messages: EmergencyWarningMessage[];
}

interface EmergencyWarningMessage {
    LanguageId: number;
    Message: string;
}
